/** USB receipt printer that should print through the local printer agent. */
export function usesPrinterAgentUsb(printer?: {
	isSDK?: boolean | null;
	connectType?: string | null;
	usePrinterAgent?: boolean | null;
} | null): boolean {
	return (
		printer?.isSDK === false &&
		printer?.connectType === 'USB' &&
		printer?.usePrinterAgent === true
	);
}
